<p class="_label"
   [dfs]="'t:p1'"
   *ngIf="label">{{label}}</p>
<div [offClickState]="expandState"
     (offClick)="closeDropdown()">

    <div class="_content">

        <!-- loader -->
        <icms-loader class="_loader"
                     *ngIf="isLoaderVisible"></icms-loader>

        <!-- side icon (optional) -->
        <icms-icon class="_sideIcon"
                   [class._hasAction]="hasSideAction"
                   (click)="sideAction()"
                   [class.col-3]="sideIcon === 'tick'"
                   *ngIf="sideIcon"
                   [icon]="sideIcon"></icms-icon>

        <!-- side text (optional) -->
        <span class="_sideText"
              [dfs]="'t:s1'"
              (click)="sideAction()">{{ sideText }}</span>

        <!-- custom arrows for number type input -->
        <div [dfs]="'d:flex flex-direction:column'"
             class="_arrows"
             *ngIf="!isLoaderVisible">
            <icms-icon class="_arrowUp"
                       [icon]="'chevron-up'"></icms-icon>
            <icms-icon class="_arrowDown"
                       [icon]="'chevron-down'"></icms-icon>
        </div>
        <ng-content></ng-content>
    </div>



    <p [dfs]="'t:p2 m-t:1q c:2'"
       *ngIf="isValidationVisible">{{ validationMsg }}</p>

    <p [dfs]="'t:p2 m-t:1q c:2'"
       *ngIf="error && !isValidationVisible">{{ error }}</p>

    <p [dfs]="'t:p2 m-t:1q'"
       *ngIf="helper && !error && !isValidationVisible">{{ helper }}</p>


    <div [dfs]="'pos:absolute z:10 right:-10px'"
         *ngIf="type && ['date','time'].includes(type) && !isDisabled">
        <!-- padding is to make sure that shadow is visible -->
        <div [iCmshideUp]="expandState">
            <icms-calendar *ngIf="type==='date' && calendarOptions"
                           [triangle]="true"
                           [(model)]="inDropdownValue"
                           (modelChange)="closeDropdown()"
                           [options]="calendarOptions"></icms-calendar>

            <icms-timepicker *ngIf="type==='time'"
                             [triangle]="true"
                             (modelChange)="closeDropdown()"
                             [openState]="expandState"
                             [(model)]="inDropdownValue"></icms-timepicker>
        </div>
    </div>
</div>
